import script from "./UserAutocompleteInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAutocompleteInput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__